import { useContext } from 'react';
import { PlanWashedLayerRendererContext } from '../../components/3D/planView/planPlacementRenderer';
import type { PlanWashedLayerProps } from '../../components/3D/planView/planPlacementRenderer';

/**
 * The washed plan's mount (`spec-onboarding-persistent-scene-wash`, R2.1): the renderer's chunk
 * provides the layer, read here inside `PlanRendererProviders`, so the page never imports three.js.
 * A renderer that could not load provides none, and the steps keep their solid page.
 */
const OnboardingWashedPlan = (props: PlanWashedLayerProps) => {
  const Layer = useContext(PlanWashedLayerRendererContext);
  return Layer ? <Layer {...props} /> : null;
};

export default OnboardingWashedPlan;
